/**
 * Keys for data stored in window.sessionStorage
 */
export enum SessionStorageKeys {
  HOLIDAY_MSG_SHOW_COUNT = 'holiday_msg_show_count',
}
